import { TriggerActionCategory } from "@octopusdeploy/octopus-server-client";
import { useAllFeedTypesForExternalFeeds } from "~/areas/projects/components/Triggers/Feed/useAllFeedTypesForExternalFeeds";
import { CreateOrEditReleaseCreationFeedTriggerPage } from "./CreateOrEditReleaseCreationFeedTriggerPage";
interface ReleaseCreationFeedTriggersPageProps {
    spaceId: string;
    projectSlug: string;
    triggerId: string;
}
export function ReleaseCreationFeedTriggerPage({ spaceId, projectSlug, triggerId }: ReleaseCreationFeedTriggersPageProps) {
    const triggerFromAllFeeds = useAllFeedTypesForExternalFeeds();
    return <CreateOrEditReleaseCreationFeedTriggerPage create={false} triggerActionCategory={TriggerActionCategory.Deployment} spaceId={spaceId} projectSlug={projectSlug} triggerId={triggerId} triggerFromAllFeeds={triggerFromAllFeeds}/>;
}
